<template>
  <div>
    <tooltip label="View" type="default" placement="left">
      <a class="button button-table is-small" @click="url()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      url () {
        window.open('#/occurrences/occurrence/' + this.data.id)
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// OccurrenceTableButtons.vue?386e894e